import React from 'react';
import { IonContent, IonPage, IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NavBar from './NavBar';

const PaymentCancel: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center justify-center min-h-screen">
          <div className="text-center p-8 bg-gray-50 rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-gray-600 mb-4">
              {t('paymentGateway.cancelled')}
            </h1>
            <p className="text-lg text-gray-700 mb-6">
              {t('paymentGateway.cancelMessage')}
            </p>
            <IonButton
              expand="block"
              onClick={() => history.push('/payment')}
            >
              {t('paymentGateway.tryAgain')}
            </IonButton>
          </div>
        </div>
        <NavBar />
      </IonContent>
    </IonPage>
  );
};

export default PaymentCancel;
